import { Styles } from "../../config"

const styles = {
	container: {
		width: "100%",
		padding: { zero: "20px", xs2: "25px", lg: "50px" },
		justifyContent: "center",
		alignItems: { zero: "center", md1: "flex-start" },
		borderRadius: "10px",
		boxShadow: "0px 40px 80px 0px #3651901F"
	},

	formContainer: {
		maxWidth: { zero: "100%", md1: "500px" },
		width: { zero: "100%", md1: "50%" }
	},

	formHeader: {
		fontSize: "3rem",
		fontWeight: "700",
		color: Styles.Color.secondary,

		"@media (min-width: 900px) and (max-width: 1072px)": {
			height: "115px"
		}
	},

	form: {
		width: "100%",
		alignItems: "center"
	},

	input: {
		width: "95%"
	},

	submitButton: {
		variant: "contained",
		disableElevation: true,
		size: "large",

		sx: {
			marginTop: "25px",
			width: "95%",
			height: "60px",
			fontSize: "1.25rem",
			fontWeight: "600",
			color: Styles.Color.white,
			background: Styles.Color.secondaryHover,

			":hover": {
				color: Styles.Color.white,
				background: Styles.Color.secondary
			}
		}
	},

	instructions: {
		fontSize: "1.5rem",
		color: Styles.Color.primary
	}
}

export default styles
